var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "109.000000pt",
    viewBox: "0 0 128.000000 109.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,109.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718 1064 c-34 -18 -48 -43 -48 -84 0 -45 16 -70 57 -86 28 -12 42 -13 69 -4 77 26 85 138 13 176 -35 18 -57 17 -91 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 798 c-67 -68 -124 -134 -128 -148 -10 -45 16 -72 130 -136 l110 -61 5 -127 c4 -111 7 -129 24 -142 27 -19 52 -18 76 6 18 18 20 33 20 169 0 82 -4 160 -9 174 -6 15 -35 37 -80 61 -39 20 -71 40 -71 44 0 8 112 122 121 122 3 0 23 -25 43 -55 l36 -55 119 0 c96 0 121 3 132 16 9 11 10 20 2 32 -8 14 -29 18 -106 20 l-96 3 -56 90 c-96 151 -110 150 -272 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962 519 c-154 -29 -246 -207 -181 -349 73 -161 265 -207 397 -94 199 170 42 493 -216 443z m149 -79 c104 -54 130 -207 51 -302 -115 -136 -343 -50 -342 129 1 155 151 244 291 173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 492 c-149 -82 -179 -275 -61 -400 51 -55 101 -76 181 -76 80 0 129 21 182 76 100 104 95 273 -11 366 -52 46 -98 62 -175 62 -53 0 -76 -6 -116 -28z m170 -33 c181 -50 197 -301 23 -374 -128 -53 -267 43 -268 186 0 53 32 123 71 151 27 20 94 47 119 48 8 0 33 -5 55 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 325 l-85 -85 53 0 52 0 -31 -62 -31 -63 86 85 c47 47 86 88 86 93 0 4 -23 7 -50 7 l-50 0 31 55 c17 30 29 55 27 55 -2 0 -41 -38 -88 -85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricBike);
export default __webpack_public_path__ + "static/media/electric-bike.dcb30d27145fcc9b6c60eb8be93ca90c.svg";
export { ForwardRef as ReactComponent };